import type { ScheduleNode } from "../types.ts";
import { scheduleDays } from "./gantt.ts";
import { leafDescendants } from "./tree.ts";

export interface StageProgress {
	progressPercent: number;
}

export type ProgressMap = Map<string, StageProgress>;

export function leafPercent(
	latest: ProgressMap | undefined,
	stageId: string,
): number {
	return latest?.get(stageId)?.progressPercent ?? 0;
}

export function branchPercent(
	leaves: ScheduleNode[],
	latest: ProgressMap | undefined,
): number {
	let weighted = 0;
	let total = 0;
	for (const leaf of leaves) {
		if (leaf.status === "cancelled") continue;
		const duration = scheduleDays(leaf.start, leaf.end);
		if (duration === null) continue;
		weighted += leafPercent(latest, leaf.id) * duration;
		total += duration;
	}
	if (total === 0) return 0;
	return Math.min(100, Math.max(0, Math.round(weighted / total)));
}

export function progressByStage(
	nodes: ScheduleNode[],
	latest: ProgressMap | undefined,
	counts: Map<string, number>,
): Map<string, number> {
	const percents = new Map<string, number>();
	nodes.forEach((node, index) => {
		if ((counts.get(node.id) ?? 0) === 0) {
			percents.set(node.id, leafPercent(latest, node.id));
			return;
		}
		percents.set(
			node.id,
			branchPercent(leafDescendants(nodes, index, counts), latest),
		);
	});
	return percents;
}
